import * as express from 'express';
import * as http from 'http';
import * as https from 'https';
import * as path from 'path';
import * as fs from 'fs';
import { addon, log } from 'pao-aop';
import { BaseServer } from '../base';
import * as connecthistoryapifallback from "connect-history-api-fallback";

/** 编码 */
const ENCODING = 'utf8'

/*
 * 版权: Copyright (c) 2018 red
 * 
 * 文件: index.ts
 * 创建日期: Monday November 5th 2018
 * 作者: pao
 * 说明:
 * 1、
 */
export let expressApp: express.Express;

/**
 * HTTPS 应用服务配置
 */
export class HttpsOption {
    /** 私钥路径 */
    privateKeyPath?: string;
    /** 证书路径 */
    certificatePath?: string;
}

/**
 * 插件：Express服务
 * 提供Express服务
 */
@addon('ExpressServer', 'Express服务', '提供Express服务')
export class ExpressServer extends BaseServer {
    /**
     * 静态网页目录
     */
    public staticDirectory?: string;

    /**
     * Http服务器
     */
    private httpServer?: http.Server;

    /**
     * Https服务器
     */
    private httpsServer?: https.Server;

    /**
     * Express服务
     * @param hostName 服务主机
     * @param httpPort http应用端口
     * @param httpsPort https应用端口
     * @param httpsOption https配置
     */
    constructor(
        public hostName?: string,
        public httpPort?: number,
        public httpsPort?: number,
        public httpsOption?: HttpsOption
    ) {
        super();
        this.hostName = hostName || 'localhost';
    }

    protected onStart?(): void {
        let app = express();
        expressApp = app;

        log('express', '设定静态目录');
        // 设定找不到的get请求跳转index.html
        app.use(connecthistoryapifallback());

        // 静态目录设定
        if (this.staticDirectory) {
            const staticPath = path.join(process.cwd(), this.staticDirectory);
            log('express', `express应用启动目录[${process.cwd()}]`);
            log('express', `静态目录'[${staticPath}]`);
            app.use(express.static(staticPath));
        }

        log('express', '过滤服务目录');
        // 过滤服务文件夹,不能通过get请求访问
        app.use(function (req: express.Request, res: express.Response, next: express.NextFunction) {
            // 设置指定文件目录
            let server = /(\/server\/)/g;
            if (server.test(req.path)) {
                // 设置utf - 8编码格式
                res.writeHead(200, { 'Content-Type': 'text/html;charset=utf-8' });
                res.end('请求非法目录文件');
            } else {
                next();
            }
        });

        // 设置端口
        app.set('port', this.httpPort);
        app.set('host', this.hostName);
        app.set('trust proxy', true);

        // 启动服务
        this.httpServer = http.createServer(app);
        this.httpServer.listen(this.httpPort, this.hostName, () => {
            log('express', `Express HTTP 服务开始在端口${this.hostName}:${this.httpPort}监听`);
        });


        if (this.httpsPort && this.httpsOption) {
            try {
                //读取公私钥文件
                const privateKey = fs.readFileSync(path.join(process.cwd(), this.httpsOption.privateKeyPath), ENCODING),
                    certificate = fs.readFileSync(path.join(process.cwd(), this.httpsOption.certificatePath), ENCODING);
                this.httpsServer = https.createServer({ key: privateKey, cert: certificate }, app);
                this.httpsServer.listen(this.httpsPort, this.hostName, () => {
                    log('express', `Express HTTPS 服务开始在端口${this.hostName}:${this.httpsPort}监听`);
                });
            } catch (error) {
                log('express', `Express HTTPS 服务开始异常，${error.message}`);
            }
        }
    }

    protected onStop?(): void {
        this.httpServer!.close();

        if (this.httpsServer) {
            this.httpsServer.close();
        }
    }
}